<template>
  <div v-if="items.length" class="public-interactions-timeline-container">
    <div v-for="(interaction, index) in items" :key="index">
      <public-interactions-event-view-timeline-item
        :item="interaction"
        :task-img-promise="getTaskImage"
      ></public-interactions-event-view-timeline-item>
    </div>
  </div>
</template>

<script>
import PublicInteractionsEventViewTimelineItem from './publicInteractionsEventViewTimelineItem';
import { GraphqlFastQuery } from '@/api/graphql';
import { query as getTask } from '@/graphql/task';

export default {
  components: {
    PublicInteractionsEventViewTimelineItem,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      taskImgPromises: {},
    };
  },
  methods: {
    getTaskImage(taskId) {
      let promise = GraphqlFastQuery(getTask, {
        fetchPolicy: 'cache-first',
        variables: {
          taskId: String(taskId),
        },
      })
        .then((response) => {
          return response.data.publicTask.icon
            ? response.data.publicTask.icon
            : response.data.publicTask.publicTaskLibrary.icon;
        })
        .catch(() => null);

      return promise;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/public/_public-interactions.scss';
</style>
